import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { ConfigurationApi } from '../../../../../../generated/internalApi/api/api';
import { DynamicEnum } from '../../../../shared/models/index';
import { SessionService } from '../../../../shared/services/session/shared/session/session-service/session.service';

export { ConfigurationApi };

@Injectable()
export class PersonalLoanConfigurationService {
  public static readonly PROP_KEY_BORROWER_PORTAL_ENABLED = 'ENABLE_NEWLOANAPP_BORROWERPORTAL';
  public static readonly PROP_KEY_BP_DISABLED_REDIRECT_URL = 'NEWLOANAPP_BORROWERPORTAL_REDIRECTURL';

  constructor(
    private configurationApi: ConfigurationApi,
    private sessionService: SessionService) {

    // Content-Type is not being set by default in the autogen classes, so setting it here.
    this.configurationApi.defaultHeaders.set('Content-Type', 'application/json');
  }

  public getAppProperty(key: string): Observable<string> {
    const authorizationString = this.sessionService.data.authData.token;

    return this.configurationApi.configurationGetClpAppProperty(
      key,
      authorizationString
    )
    .map(response => response.data)
    .catch(err => Observable.throw(err));
  }

  public getAppPropertyBool(key: string): Observable<boolean> {
    const authorizationString = this.sessionService.data.authData.token;

    return this.configurationApi.configurationGetClpAppProperty(
      key,
      authorizationString
    )
    .map(response => response.data && response.data.toLowerCase() === 'true')
    .catch(err => Observable.throw(err));
  }

  public getEnumKeyValuePair(enumName: string): Observable<DynamicEnum[]> {
    const authorizationString = this.sessionService.data.authData.token;

    return this.configurationApi.configurationGetPublicEnumKeyValuePair(
      enumName,
      authorizationString
    )
    .map(response => response.data)
    .catch(err => throwError(err));
  }

  public getUploadedDocumentTypes(): Observable<DynamicEnum[]> {
    return this.getEnumKeyValuePair('UploadedDocumentType');
  }
}
